import { gql } from '@apollo/client'
import PAGINATED_PAGE_INFO_FRAGMENT from 'apollo/fragments/PAGINATED_PAGE_INFO_FRAGMENT'

// PROVIDERS_PAGE

export default gql`
  query providers(
    $cursor: String
    $filters: RibbonHealthDoctorsWithoutDefaultsFilterInput
    $member_plan_id: ID
    $member_has_plan: Boolean!
    $employee_id: ID
  ) {
    ribbon_health_doctors_without_defaults_v2(
      first: 25
      after: $cursor
      filters: $filters
      employee_id: $employee_id
    ) {
      nodes {
        id
        isProvider @client
        npi_id
        full_name
        rating
        ratings_count
        image_url
        specialty_names
        updated_at
        addresses(min_confidence: 0) {
          address
          phone
          uuid
          zip
          confidence
          latitude
          longitude
          distance
          rightway_primary
        }
        confirmed
        confirmed_at
        confirmed_by {
          full_name
        }
        high_patient_satisfaction
        high_quality_practice_location
        high_quality_provider
        low_cost_provider
        insurance_tier(insurance_plan_id: $member_plan_id)
          @include(if: $member_has_plan) {
          name
        }
        source
      }
      pageInfo {
        ...PAGINATED_PAGE_INFO_FRAGMENT
      }
    }
  }
  ${PAGINATED_PAGE_INFO_FRAGMENT}
`
